import { FooterMaximized } from "components/footerfull";
import Header from "components/headerfull";
import { Banner, SEOgenericContent } from "./subCategory";


const MLtext = {
    "titles": {
        "h1": [
            {
                "text": "Mentions Légales",
                "isgrad": false
            }
        ]
    },
    "data": [
        {
            "h2": "Mentions Légales Wall Of Share",
            "contents": [
            ]
        },
        {
            "h2": "Éditeur du Site",
            "contents": [
                {
                    "type": "paragraph",
                    "inner": "Wall Of Share\nSAS\n198 avenue de Verdun 92130 contact@wall-of-share.com\nSIRET: 94915570900015\nDirecteur de la Publication : William Cohen"
                },
            ]
        },
        {
            "h2": "Hébergeur du Site",
            "contents": [
                {
                    "type": "paragraph",
                    "inner": "AWS\n31 Place des Corolles 92400 Courbevoie"
                },
            ]
        },
        {
            "h2": "Propriété Intellectuelle",
            "contents": [
                {
                    "type": "paragraph",
                    "inner": "Tous les contenus présents sur le site, tels que les textes, les images, les vidéos, les logos, etc., sont la propriété exclusive de Wall Of Share ou de ses partenaires et sont protégés par les lois françaises et internationales sur le droit d'auteur et la propriété intellectuelle. Toute reproduction, distribution, modification ou exploitation de ces contenus sans l'autorisation préalable écrite de Wall Of Share est strictement interdite."
                },
            ]
        },
        {
            "h2": "Protection des Données Personnelles",
            "contents": [
                {
                    "type": "paragraph",
                    "inner": "La collecte et le traitement des données personnelles sur ce site sont effectués dans le respect de la réglementation en vigueur, notamment la loi n° 78-17 du 6 janvier 1978 relative à l'informatique, aux fichiers et aux libertés, ainsi que le Règlement Général sur la Protection des Données (RGPD) du 27 avril 2016. Pour en savoir plus sur la manière dont nous traitons vos données personnelles, veuillez consulter notre Politique de Confidentialité."
                },
            ]
        },
        {
            "h2": "Cookies",
            "contents": [
                {
                    "type": "paragraph",
                    "inner": "Ce site utilise des cookies pour améliorer l'expérience utilisateur, réaliser des statistiques d'audience et proposer des publicités adaptées à vos centres d'intérêt. En continuant à naviguer sur ce site, vous acceptez l'utilisation de cookies. Pour en savoir plus sur l'utilisation des cookies sur ce site, veuillez consulter notre Politique en matière de Cookies."
                },
            ]
        },
        {
            "h2": "Responsabilité",
            "contents": [
                {
                    "type": "paragraph",
                    "inner": "Wall of Share s'efforce de fournir des informations exactes et à jour sur ce site, mais ne peut garantir l'exactitude, l'exhaustivité ou la pertinence des informations fournies. En conséquence, Wall Of Share décline toute responsabilité en cas d'éventuelles erreurs, omissions ou résultats obtenus à la suite de l'utilisation de ces informations."
                },
            ]
        },
        {
            "h2": "Liens Hypertextes",
            "contents": [
                {
                    "type": "paragraph",
                    "inner": "Ce site peut contenir des liens hypertextes vers d'autres sites internet.Wall Of Share n'exerce aucun contrôle sur le contenu de ces sites et décline toute responsabilité quant à l'accès, au contenu ou à l'utilisation de ces sites."
                },
            ]
        },
        {
            "h2": "Litiges",
            "contents": [
                {
                    "type": "paragraph",
                    "inner": "Les présentes conditions d'utilisation sont régies, interprétées et appliquées conformément au droit français. Tout litige relatif à l'utilisation du site sera de la compétence exclusive des tribunaux français."
                },
            ]
        },
        {
            "h2": "Contact",
            "contents": [
                {
                    "type": "paragraph",
                    "inner": "Pour toute question ou demande concernant ces mentions légales, veuillez nous contacter à l'adresse suivante : contact@wall-of-share.com"
                },
            ]
        },
    ]
};

export default function ML() {
    return <>
        <Header type="default" />

        <Banner data={MLtext} nobg={true} slim={true} />

        <div className="w-[90%] max-w-[1000px] mx-auto py-[100px] flex flex-col gap-[40px]">
            <SEOgenericContent content={MLtext} indent={true} lessSpace={true} />
        </div>
        <FooterMaximized />
    </>;
};